export default __webpack_public_path__ + "static/media/down-arrow.29ad2d26.svg";